import React, { Component } from "react";
import { NavLink, Link } from "react-router-dom";
import "./header.css";

export default class Header extends Component {
	constructor() {
      super();
			this.state={mobileHeader:false};

  }
	toggleMobileHeader = () =>{
		if(this.state.mobileHeader){
			this.setState({mobileHeader:false})
		}
		else{
			this.setState({mobileHeader:true})
		}
	}
	render() {
		return (
      <div id="header" className="header-background primary-background">
				<div className="mobile-menu-toggle" onClick={this.toggleMobileHeader}>
					<img className="full-width" src="/images/menu-icon.png" />
				</div>
        <div className="logo-container">
          <NavLink className="logo" exact to="/" activeClassName="active">
						<img src="/images/logo.png" />
          </NavLink>
        </div>
				<div className="menu">
					<Link className="nav-link" to="/" activeClassName="active">
						<div className="menu-item uppercase">
							Home
						</div>
					</Link>
					<NavLink className="nav-link" to="/portfolio" activeClassName="active">
						<div className="menu-item uppercase">
							Portfolio
						</div>
					</NavLink>
					<NavLink className="nav-link" to="/services" activeClassName="active">
						<div className="menu-item uppercase">
							Services
						</div>
					</NavLink>
					<NavLink className="nav-link" to="/testimonials" activeClassName="active">
						<div className="menu-item uppercase">
							Testimonials
						</div>
					</NavLink>
					<NavLink className="nav-link" to="/contact" activeClassName="active">
						<div className="menu-item uppercase">
							Contact
						</div>
					</NavLink>
					<a href="tel:(650) 255-4768" className="nav-link">
						<div className="menu-item uppercase accent-background" style={{borderRadius: "4px", height: "50px", padding: "20px 50px"}}>
							(650) 255-4768
						</div>
					</a>
				</div>
				{this.state.mobileHeader &&
					<div id="mobile-header" className="primary-background">
						<div id="mobile-menu-close" onClick={this.toggleMobileHeader}>
							<img style={{width: "30px"}} src="/images/close-icon.png" />
						</div>
						<div className="small-padding centered-text">
							<NavLink className="nav-link" to="/" activeClassName="active" onClick={this.toggleMobileHeader}>
								<div className="menu-item uppercase">
									Home
								</div>
							</NavLink>
							<NavLink className="nav-link" to="/portfolio" activeClassName="active" onClick={this.toggleMobileHeader}>
								<div className="menu-item uppercase">
									Portfolio
								</div>
							</NavLink>
							<NavLink className="nav-link" to="/services" activeClassName="active" onClick={this.toggleMobileHeader}>
								<div className="menu-item uppercase">
									Services
								</div>
							</NavLink>
							<NavLink className="nav-link" to="/testimonials" activeClassName="active" onClick={this.toggleMobileHeader}>
								<div className="menu-item uppercase">
									Testimonials
								</div>
							</NavLink>
							<NavLink className="nav-link" to="/contact" activeClassName="active" onClick={this.toggleMobileHeader}>
								<div className="menu-item uppercase">
									Contact
								</div>
							</NavLink>
							<a href="tel:(650) 255-4768" className="nav-link" onClick={this.toggleMobileHeader}>
								<div className="menu-item uppercase accent-background">
									(650) 255-4768
								</div>
							</a>
						</div>
		      </div>
				}
      </div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/header/index.js